export class StepFcnConstants {
}
StepFcnConstants.EXECUTE_SECONDS = 300; // 5 mins
StepFcnConstants.RUNNING_SECONDS = 300; // 5 mins
StepFcnConstants.RUNNING_LIMIT = 10;
StepFcnConstants.END_PLACEHOLDER = new Date(0).toISOString(); // 1970-01-01T00:00:00.000Z
//# sourceMappingURL=stepFcnConstants.js.map